var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParking = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M30.5 20c0 5.799-4.701 10.5-10.5 10.5S9.5 25.799 9.5 20 14.201 9.5 20 9.5 30.5 14.201 30.5 20Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#464646",
  d: "M23.608 17.73c0 .666-.218 1.226-.647 1.664s-1.088.658-1.958.658h-2.77v-4.669h2.77c.87 0 1.528.224 1.958.666s.647 1.008.647 1.68m.136-2.416c-.648-.604-1.57-.91-2.741-.91h-3.884v11.194h1.115v-4.564h2.769c1.172 0 2.094-.303 2.74-.903.65-.602.979-1.414.979-2.416 0-.987-.33-1.794-.978-2.4"
}))));
export default SvgParking;